export const KpiEN = {
    "kpi": "KPI List"
}